module.exports = __webpack_public_path__ + "media/bandicam 2021-06-23 10-54-49-516.4984314b.mp4";